export const CONTENT_TYPES = {
  scenario: "scenario",
  trainer: "trainer",
};

export function isTrainerGame(game) {
  return game?.settings?.contentType === CONTENT_TYPES.trainer;
}

export function getContentTypeLabel(contentType) {
  return contentType === CONTENT_TYPES.trainer ? "Тренажёр" : "Сценарий";
}

export function getMaxButtonsForGame(game) {
  return isTrainerGame(game) ? 4 : 2;
}
